import React from "react";

// toaster 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Toaster() {

    const successToast = () => toast.success("Susccess", {
        position: "bottom-right"
    });

    const errorToast = () => toast.error("Error", {
        position: "bottom-right"
    });

    return (
        <>
            <button onClick={successToast}>Success</button>
            <button onClick={errorToast}>Error</button>
            <ToastContainer />
        </>
    )
}
export default Toaster;